import { TrackingDetails } from '~/lib/types/tracking-types';
import type { Namespace, TFunction } from 'i18next';

export const mapParcelStage = (parcel: TrackingDetails) => {
  if (parcel) {
    if (hasDeliveryIssue(parcel)) return 'TRACKING_STAGE_ISSUE';
    if (parcel.currentStage === 'Delivered') return 'TRACKING_STAGE_DELIVERED';
    if (parcel.currentStage === 'DeliveryScheduled') return 'TRACKING_STAGE_DELIVERY_SCHEDULED';
    if (parcel.currentStage === 'AtDepot') return 'TRACKING_STAGE_AT_DEPOT';
    if (parcel.currentStage === 'InTransit') return 'TRACKING_STAGE_IN_TRANSIT';
    if (parcel.currentStage === 'Collected') return 'TRACKING_STAGE_COLLECTED';
    if (parcel.currentStage === 'DroppedOff') return 'TRACKING_STAGE_DROPPED_OFF';
  }
  return 'TRACKING_STAGE_NULL';
};

export const translatedTrackingStage = (t: TFunction<Namespace, undefined>, stage: string) => {
  // This function could be simplified by passing stage as a key to the translation function directly.
  // However, we keep it as is so that we can easily extract the translation keys. `npm run i18n:extract`
  if (stage === 'TRACKING_STAGE_ISSUE') return t('TRACKING_STAGE_ISSUE', 'Issue');
  if (stage === 'TRACKING_STAGE_DELIVERED') return t('TRACKING_STAGE_DELIVERED', 'Delivered');
  if (stage === 'TRACKING_STAGE_DELIVERY_SCHEDULED') return t('TRACKING_STAGE_DELIVERY_SCHEDULED', 'Out for Delivery');
  if (stage === 'TRACKING_STAGE_AT_DEPOT') return t('TRACKING_STAGE_AT_DEPOT', 'At Depot');
  if (stage === 'TRACKING_STAGE_IN_TRANSIT') return t('TRACKING_STAGE_IN_TRANSIT', 'In Transit');
  if (stage === 'TRACKING_STAGE_COLLECTED') return t('TRACKING_STAGE_COLLECTED', 'Collection');
  if (stage === 'TRACKING_STAGE_DROPPED_OFF') return t('TRACKING_STAGE_DROPPED_OFF', 'Dropped Off');
  if (stage === 'TRACKING_STAGE_NULL') return t('TRACKING_STAGE_NULL', '');
  return '';
};

export const hasDeliveryIssue = (parcel: TrackingDetails) => {
  return (
    parcel.isDamaged ||
    parcel.isLost ||
    parcel.isRTS ||
    parcel.isHeldInCustoms ||
    parcel.isDelayed ||
    parcel.isProhibited ||
    parcel.isOversize ||
    parcel.isProblem ||
    parcel.isCancelled ||
    parcel.addressIssue ||
    parcel.deliveryFailed
  );
};
